import type { MailboxInfo } from 'owa-client-types';
import { isLicensingMailboxInfo } from 'owa-account-source-list-types/lib/utils/isLicensingMailboxInfo';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getCoprincipalAccountForMailboxInfo } from 'owa-account-source-list-store';

/**
 * Resolves a mailbox info to its linked licensing mailbox info if available.
 *
 * This utility can be safely called at any level of the stack (UI components, service layers, etc.)
 * and will correctly resolve to the licensing mailbox. If already a licensing mailbox or no linked
 * licensing mailbox exists, returns the original mailbox info.
 *
 * @param mailboxInfo - The mailbox info to resolve
 * @returns The linked licensing mailbox info if available, otherwise the original mailbox info
 */
export function getLinkedLicensingMailboxInfoOrSelf(mailboxInfo: MailboxInfo): MailboxInfo {
    if (!isGlobalFeatureEnabled('acct-enable-cloud-cache-bizchat')) {
        return mailboxInfo;
    }

    // Already a licensing mailbox, return as-is
    if (isLicensingMailboxInfo(mailboxInfo)) {
        return mailboxInfo;
    }

    // Check for linked licensing mailbox in coprincipal account
    const account = getCoprincipalAccountForMailboxInfo(mailboxInfo);
    if (account?.licensingMailboxInfo) {
        return account.licensingMailboxInfo;
    }

    return mailboxInfo;
}
